import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { ProgramsBillingName, AppFields, Store, AppState, map, Observable, ClubProgram } from '../../../store';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css'],
})
export class PageHeaderComponent implements OnInit {
  @Output() deleteProgramsEvent = new EventEmitter();
  @Output() deleteMembersEvent = new EventEmitter();
  @Output() deleteFeesEvent = new EventEmitter();
  @Output() deleteQuestionsEvent = new EventEmitter();
  @Output() newQuestionsEvent = new EventEmitter();
  @Output() filterProgramsEvent = new EventEmitter();
  @Output() changeProgramStatusEvent = new EventEmitter();
  @Output() memberSearchEvent = new EventEmitter();
  @Output() memberSetTeamEvent = new EventEmitter();
  @Output() memberAddEvent = new EventEmitter();
  @Output() deleteFormEvent = new EventEmitter();

  @Output() openFinancialEvent = new EventEmitter();
  @Output() openExportEvent = new EventEmitter();
  @Output() openFormEvent = new EventEmitter();
  @Output() searchEvent = new EventEmitter();
  @Output() EmailEvent = new EventEmitter();
  @Output() ExportEvent = new EventEmitter();
  @Output() remove = new EventEmitter();

  @Input() NoOfSelectedProgram: number;
  @Input() NoOfSelectedMember: number;
  @Input() NoOfSelectedFees: number;
  @Input() NoOfSelectedQuestion: number;
  @Input() NoOfSelectedDiscount: number;
  @Input() NoOfSelectedForm: number;

  @Input() isReportPage: boolean;
  @Input() showRemove: boolean;
  @Input() hideBreadcrumb: boolean;

  @Input() PageHeaderName: Observable<string>;
  @Input() hideSmallHeader: boolean;

  program: Observable<string>;
  subscription: Subscription;
  currentUrl = '';
  routeParams;
  program_status = '';
  programStatusForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    public router: Router,
    private store: Store<AppState>
  ) {
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.routeParams = this.activeRoute.snapshot.params;

    if (!this.PageHeaderName) {
      this.PageHeaderName = this.store.select(AppFields.App, AppFields.BillingTypeID).pipe(map(t => {
        return ProgramsBillingName[t] || '';
      }));
    }

    this.program = this.store.select(AppFields.App, AppFields.Program).pipe(map(p => p && p.name || 'Let\'s create'));

    if (this.routeParams.status) {
      let statusDropDown = '';
      if (this.routeParams.status === 'inactive') {
        statusDropDown = '0';
      } else if (this.routeParams.status === 'active') {
        statusDropDown = '1';
      } else if (this.routeParams.status === 'archive') {
        statusDropDown = '2';
      }
      this.programStatusForm = this.fb.group({
        program_status: [statusDropDown, [Validators.required]],
      });
    }
  }

  /* Go to create a new program page. */
  newProgram() {
    this.router.navigate(['club/add']);
  }

  /* Go to list of programs page. */
  backProgram() {
    this.router.navigate(['programs/active']);
  }

  /* Go to create a new fee page. */
  newFee() {
    const RP = this.routeParams;
    this.router.navigate([
      '/programs/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1'
    ]);
  }

  backToFees(programName, clubProgramID, programStatus) {
    this.router.navigate([
      'programs/' + programName + '/' + clubProgramID + '/' + programStatus + '/fee'
    ]);
  }

  backToMembers(programName, clubProgramID, programStatus) {
    this.router.navigate([
      'members/' + programName + '/' + clubProgramID + '/' + programStatus
    ]);
  }

  deleteSelectedProgramRecords() {
    this.deleteProgramsEvent.emit('test');
  }

  issearch() {
    this.searchEvent.emit('test');
  }

  isEmail() {
    this.EmailEvent.emit('test');
  }

  isExport() {
    this.ExportEvent.emit('test');
  }

  deleteSelectedMemberRecords() {
    this.deleteMembersEvent.emit('test');
  }

  deleteSelectedFeeRecords() {
    this.deleteFeesEvent.emit('test');
  }

  deleteSelectedForm() {
    this.deleteFormEvent.emit('test');
  }

  filterProgramListing(obj) {
    this.program_status = obj;
    this.filterProgramsEvent.emit(this.program_status);
  }

  changeProgramStatus(obj) {
    this.changeProgramStatusEvent.emit(obj);
  }

  newPayment(obj) {
    this.openFinancialEvent.emit(obj);
  }
  exportTransectionFile(obj) {
    this.openExportEvent.emit(obj);
  }

  newForm(obj) {
    this.openFormEvent.emit(obj);
  }

  isCurrentFeeFormPage() {
    const RP = this.routeParams;
    return this.router.url === '/programs/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1'
      || this.router.url === '/programs/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1/' + RP.feeId
      || this.router.url === '/programs/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step2/' + RP.feeId
      || this.router.url === '/programs/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step3/' + RP.feeId;
  }

  onMemberSearch() {
    this.memberSearchEvent.emit('test');
  }

  onMemberTeamAssign() {
    console.log('here onMemberTeamAssign');
    this.memberSetTeamEvent.emit('test');
  }

  onNewMember() {
    this.memberAddEvent.emit('test');
  }

  onRemove() {
    this.remove.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/page-header/page-header.component.ts